import React, { useState, useEffect } from 'react';
import Popup from 'components/popup/popup';
import CustomTable from 'components/CustomTable';
import CustomButton from 'components/CustomInput/Button/index';
import useApplicationDocument from 'hooks/review/useApplicationDocument';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import { Grid } from '@material-ui/core';
import CustomTextField from 'components/Input/CustomTextField';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import CustomPagination from 'components/CustomPagination';
import { useDispatch, useSelector } from 'react-redux';
import PageSize from 'components/CustomTable/PageSize';
import { GET_APPLICATION_DOC_BYPARAMS } from 'store/key';
import { SELECT_ONE } from 'utility/frontendMessage';
import useDialog from 'components/ConfirmDialog/useDialog';
export default function ApplicationDoc({ isEditMode, handleSave, applicationList = [] }) {
    const showDialog = useDialog();
    const dispatch = useDispatch();
    const [selectedRows, setSelectedRows] = useState([]);
    const { applicationDocData } = useSelector((state) => state.arrangeMeeting);
    const [isInit, setInit] = useState(false);
    const { columns, selectedColumns } = useApplicationDocument({ selectedRows, setSelectedRows, applicationDocData });
    const [isAppLicDocLoading, setIsAppLicDocLoading] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedList, setSelectedList] = useState(applicationList);

    const [searchCriteria, setSearchCriteria] = useState({
        criteria: 'appNo',
        param: '',
        page: 1,
        pageSize: 10,
        isDesc: true,
        sort: 'confirmDate',
    });

    const [isSeach, setIsSeach] = useState({
        criteria: 'appNo',
        param: '',
        page: 1,
        pageSize: 10,
        isDesc: true,
        sort: 'confirmDate',
    });

    let listOfCriteria = [
        // { display: 'Submission No.', key: 'subNo' },
        { display: 'CRER Application No.', key: 'appNo' },
        { display: 'IRB/REC Ref. No.', key: 'refNo' },
    ];
    useEffect(() => {
        if (openPopup) {
            getApplicationDocByParams(searchCriteria);
            setSelectedRows(selectedList);

            // clear rows when popup open
            setInit(false);
        }
        setSelectedList(applicationList);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openPopup]);

    useEffect(() => {
        setSelectedList(applicationList);
    }, [applicationList]);

    const getApplicationDocByParams = (params) => {
        if (params.param.length >= 255) return;
        setIsAppLicDocLoading(true);
        dispatch({
            type: GET_APPLICATION_DOC_BYPARAMS,
            payload: {
                params,
                callback: () => {
                    setIsAppLicDocLoading(false);
                    setIsSeach(params);
                    setInit(true);
                },
            },
        });
    };
    const deleteSelectedRow = (row, isAdd) => {
        const index = selectedRows.findIndex((item) => item.id === row.id);
        if (index !== -1) {
            const newSelectedRows = [...selectedRows];
            newSelectedRows.splice(index, 1);
            setSelectedRows(newSelectedRows);
            if (isAdd) {
                handleSave({ applicationList: newSelectedRows });
                setSelectedList(newSelectedRows);
            }
        }
    };

    const cancelSelectAppDoc = () => {
        setOpenPopup(false);
        setSearchCriteria({ criteria: 'appNo', param: '', page: 1, pageSize: 10, isDesc: true, sort: 'confirmDate' });
    };

    const handleConfirm = () => {
        if (selectedRows.length === 0) {
            showDialog({
                description: SELECT_ONE,
                disableCancelButton: true,
            });
            return;
        }
        setOpenPopup(false);
        setSelectedList(selectedRows);
        handleSave({ applicationList: selectedRows });
    };
    const handleClear = () => {
        setSearchCriteria({ criteria: 'appNo', param: '', page: 1, pageSize: 10, isDesc: true, sort: 'confirmDate' });
        getApplicationDocByParams({
            criteria: 'appNo',
            param: '',
            page: 1,
            pageSize: 10,
            isDesc: true,
            sort: 'confirmDate',
        });
    };
    const setDisabled = () => {
        if (isSeach.criteria === 'appNo' && isSeach.param === '' && isSeach.page === 1 && isSeach.pageSize === 10) {
            return true;
        } else {
            return false;
        }
    };
    return (
        <div>
            <Popup
                width="1200px"
                title="Add Application Document"
                open={openPopup}
                footerActions={[
                    { label: 'Cancel', clicked: cancelSelectAppDoc, color: 'default' },
                    { label: 'Confirm', clicked: handleConfirm },
                ]}
                closePopup={cancelSelectAppDoc}
            >
                <Grid container direction="column" style={{ padding: 10 }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <TextSubHeader style={{ paddingRight: 10, width: 200 }}>Search Application Document: </TextSubHeader>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Grid container alignItems="center" wrap="nowrap">
                                <div style={{ marginRight: 5 }}>
                                    <CustomOutlineSelect
                                        label="Criteria"
                                        value={searchCriteria.criteria}
                                        onChange={(e) => {
                                            setSearchCriteria({ ...searchCriteria, criteria: e.target.value });
                                            getApplicationDocByParams({ ...searchCriteria, criteria: e.target.value });
                                        }}
                                        choices={listOfCriteria}
                                    />
                                </div>
                                <div style={{ width: 400, marginRight: 5 }}>
                                    <CustomTextField
                                        label={'Keyword'}
                                        value={searchCriteria.param}
                                        maxLength={255}
                                        style={{ width: 400 }}
                                        onChange={(e) =>
                                            setSearchCriteria({ ...searchCriteria, param: e.target.value })
                                        }
                                        onPressEnter={() => {
                                            setSearchCriteria({ ...searchCriteria, page: 1 });
                                            getApplicationDocByParams({ ...searchCriteria, page: 1 });
                                        }}
                                    />
                                </div>
                            </Grid>

                            <CustomButton
                                onClick={() => {
                                    setSearchCriteria({ ...searchCriteria, page: 1 });
                                    getApplicationDocByParams({ ...searchCriteria, page: 1 });
                                }}
                                disabled={searchCriteria.param === ''}
                                style={{ height: 38 }}
                            >
                                Search
                            </CustomButton>
                            <CustomButton
                                style={{ marginLeft: 5, height: 38 }}
                                onClick={handleClear}
                                disabled={setDisabled()}
                            >
                                Reset
                            </CustomButton>

                            <div style={{ paddingLeft: 10 }}>
                                <PageSize
                                    value={searchCriteria.pageSize}
                                    label={'Page Size'}
                                    onChange={(pageSize) => {
                                        setSearchCriteria({ ...searchCriteria, page: 1, pageSize });
                                        getApplicationDocByParams({ ...searchCriteria, page: 1, pageSize });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 15 }}>
                        <CustomTable
                            loading={isAppLicDocLoading}
                            rows={!isInit ? [] : applicationDocData?.result || []}
                            columns={columns}
                            skipMaxHeight={false}
                            maxHeight={280}
                        />
                    </div>
                    <div style={{ margin: '10px 0' }}>
                        <CustomPagination
                            page={searchCriteria.page}
                            pageSize={searchCriteria.pageSize}
                            total={applicationDocData?.total || 0}
                            onPageChange={(page) => {
                                setSearchCriteria({ ...searchCriteria, page });
                                getApplicationDocByParams({ ...searchCriteria, page });
                            }}
                        />
                    </div>

                    <div style={{ borderTop: '2px solid #dcdcdc', marginTop: 15 }}></div>

                    <div style={{ marginTop: 15 }}>
                        <TextSubHeader>Selected Application Document:</TextSubHeader>
                        <div style={{ marginTop: 10 }}>
                            <CustomTable
                                rows={selectedRows}
                                columns={selectedColumns}
                                isDeleteAllow
                                onDelete={(item) => deleteSelectedRow(item, false)}
                                skipMaxHeight={false}
                                maxHeight={280}
                            />
                        </div>
                    </div>
                </Grid>
            </Popup>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextSubHeader>Application Document:</TextSubHeader>
                {isEditMode && (
                    <CustomButton style={{ marginLeft: 10 }} onClick={() => setOpenPopup(true)}>
                        Add
                    </CustomButton>
                )}
            </div>
            <div style={{ marginTop: 20 }}>
                <CustomTable
                    isDeleteAllow={isEditMode}
                    onDelete={(item) => deleteSelectedRow(item, true)}
                    columns={selectedColumns}
                    rows={selectedList}
                    allowResize
                    // fullWidthTable={false}
                    // skipMaxHeight={false}
                />
            </div>
        </div>
    );
}
